import { render, staticRenderFns } from "./LineLabel.vue?vue&type=template&id=1a6d1e42&scoped=true&"
import script from "./LineLabel.vue?vue&type=script&lang=js&"
export * from "./LineLabel.vue?vue&type=script&lang=js&"
import style0 from "./LineLabel.vue?vue&type=style&index=0&id=1a6d1e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6d1e42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6d1e42')) {
      api.createRecord('1a6d1e42', component.options)
    } else {
      api.reload('1a6d1e42', component.options)
    }
    module.hot.accept("./LineLabel.vue?vue&type=template&id=1a6d1e42&scoped=true&", function () {
      api.rerender('1a6d1e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/LineLabel.vue"
export default component.exports